import { format, min } from "date-fns"
import { Section } from "design-system/molecules/Section"
import { useGetBiMetricsQuery } from "modules/backoffice/hooks/bi/useGetBiMetricsQuery"
import { TimeRangeSelector } from "modules/shared/components/TimeRange/TimeRangeSelector"
import { useTranslation } from "react-i18next"
import { Route as BiRoute } from "routes/_base/_auth/backoffice/bi/route"
import {
  DAILY_TIME_DIMENSIONS,
  getTimeRange,
  resolveTimeDimension,
  TimeDimensionEnum,
} from "schema"
import { CompanySelector } from "../CompanySelector"
import { BackofficeBiDisplay } from "./BackofficeBiDisplay"
import { RegenerateMetricsDialog } from "./RegenerateMetricsDialog"

export const BackofficeBi = () => {
  const { t } = useTranslation()
  const navigate = BiRoute.useNavigate()
  const search = BiRoute.useSearch()

  const { timeFrame } = search
  const range = getTimeRange(timeFrame)
  const timeDimension = resolveTimeDimension(
    range,
    search.timeDimension ?? TimeDimensionEnum.Day,
    DAILY_TIME_DIMENSIONS,
  )

  const { data, isPending } = useGetBiMetricsQuery({
    companyId: search.companyId,
    from: format(range.from, "dd/MM/yyyy"),
    to: format(min([range.to, new Date()]), "dd/MM/yyyy"),
  })

  const handleCompanyChange = (companyId: string | undefined) => {
    const newSearch = {
      ...search,
      companyId,
    }

    navigate({ search: newSearch })
  }

  const action = (
    <div className="flex flex-row gap-2 items-center w-full">
      <CompanySelector value={search.companyId} onChange={handleCompanyChange} className="h-10" />
      <TimeRangeSelector
        value={timeFrame}
        dimension={timeDimension}
        dimensions={DAILY_TIME_DIMENSIONS}
        onChange={(value) => navigate({ search: (current) => ({ ...current, ...value }) })}
      />
      <RegenerateMetricsDialog />
    </div>
  )

  return (
    <div className="flex flex-col gap-8 w-full h-full">
      <Section
        title={t("backoffice.bi.title")}
        description={t("backoffice.bi.description")}
        action={action}
      />
      <BackofficeBiDisplay
        data={data}
        isPending={isPending}
        range={range}
        timeDimension={timeDimension}
      />
    </div>
  )
}
